import { useAsyncFn } from 'react-use-v13';
import { SearchResultV2 } from '@scale/shared/types/chat';
import apiFetch from 'react-scale/lib/api-fetch';

const useFetchSearchResults = (
  processSearchResults: (
    searchTerm: string,
    searchJustification: string,
    searchResults: SearchResultV2[],
  ) => void,
) => {
  return useAsyncFn(
    async (searchTerm?: string, searchJustification?: string) => {
      if (!searchTerm || !searchJustification) {
        throw new Error('No search term is provided');
      }

      const { searchResults } = await apiFetch(null, `internal/contentUnderstanding/googleSearch`, {
        method: 'POST',
        body: { searchTerm },
      });

      if (!searchResults) {
        throw new Error('No search results');
      } else {
        processSearchResults(searchTerm, searchJustification, searchResults);
      }
    },
    [processSearchResults],
  );
};

export default useFetchSearchResults;
